import { ReactionCountType } from "@shared/Types/Reactions/ReactionTypes.types";
import {
    CommentCursorableType,
    PostCursorableType,
    StoryCursorableType,
} from "../Hooks/InfiniteScroll/cursor.types";
import { UserTrust } from "@shared/types";
import { PollType } from "../../Presentation/Components/Post/Post.types";

export enum POST_TYPES {
    TIPP_GAME = "tipp_game",
    POLL = "poll",
}

export type PostResult = {
    commentCount: number;
    content: string;
    createdAt: Date;
    deletedAt: Date;
    group: PostGroupType | null;
    id: number;
    images: PostImage[];
    isEditorial: boolean;
    isHighlighted: boolean;
    isMediaUnderProcessing: boolean;
    latestComment: ApiResponsePreviewComment;
    poll: PollType | undefined;
    reactionCountSum: number;
    releasedAt: Date;
    releasedBy: number;
    suspendedAt: Date;
    type: POST_TYPES | undefined;
    updatedAt: Date;
    user: PreviewCommentUserType;
    videos: PostImage[];
    externalSourceType?: string;
    geoLat?: number;
    geoLong?: number;
    isQuestion?: boolean;
    isReviewed?: boolean;
    linkoutUrl?: string;
    location?: {
        distanceToReference: number;
        geoLat: number;
        geoLong: number;
        id: string;
        name: string;
        subline: string;
        types: [];
    };
    oldLocation?: string;
    reactionCount?: any;
    viewCount?: number;
};

export type ActiveBookingType = {
    endAt: string;
    groupName: string;
    groupParentName: string;
    startAt: string;
    travelerAgeRange: string;
    travelerType: string;
};

export type ModerationPostUserType = PreviewCommentUserType & {
    activeBooking?: ActiveBookingType;
};

export type PreviewCommentUserType = {
    uuid: string;
    screenName: string;
    avatar: string | undefined;
    role: string;
    gender: string;
    trust: UserTrust;
};

export type ApiResponsePreviewComment = {
    content: string;
    createdAt: Date;
    createdBy: PreviewCommentUserType;
    deletedAt: Date | null;
    id: number;
    images: PostImage[];
    isEditorial: boolean;
    isOwn: boolean;
    postId: number;
    releasedAt: Date | null;
    suspendedAt: Date | null;
    updatedAt: Date | null;
    reactionCount: ReactionCountType;
    userReactions: string[];
    linkoutUrl?: string;
};

export type PostImage = {
    id: number;
    url: string;
    thumbnailUrl: string;
};

type PostGroupType = {
    id: number;
    name: string;
    image: string;
    isActive?: boolean;
    location: GroupLocationType;
    postsCount: number;
    type: string;
    parentName?: string;
    geoLat?: number;
    geoLong?: number;
    subline: string;
    cityName?: string;
    regionName?: string;
    countryName?: string;
};
export type GroupLocationType = {
    geoLat: number;
    geoLong: number;
    id: number;
    type: string;
};

export type Order = "DESC" | "ASC";

export type RequestCriteriaType = {
    cursor?: PostCursorableType | StoryCursorableType | CommentCursorableType;
    excludeActive?: boolean;
    "filter[product]"?: string;
    groupId?: number;
    groupIds?: number[];
    hasLocation?: boolean;
    increaseCount?: boolean;
    isHighlighted?: number;
    isQuestion?: number;
    lastId?: string;
    limit?: number;
    offset?: number;
    "orderBy[direction]"?: Order;
    "orderBy[field]"?: string;
    selectedGroups?: string[];
    postId?: number;
    query?: string;
    sinceDays?: number;
    unread?: boolean;
    upd?: string;
};

export type PollOption = {
    content: string;
    id: number;
    postId: number | string;
    respondedAt: string | null;
    responseHighlights: PollOptionResponse[];
    responsesCount: number;
};

export type PollOptionResponse = {
    avatar: string | null;
    gender: string | null;
    uuid: string;
};

export type ApiUserConversationsForPost = {
    imageUrl: string | null;
    key: string;
    name: string;
};
